import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'abs'
})
export class AbsPipe implements PipeTransform {

  transform(val: string|number): string|number {
		if( typeof val === 'string' ){
			if ( val.charAt(0) === '$' ){
				let num = val.substring(1);
				num = ''+Math.abs(parseFloat(num));
				return '$'+num;
			}
			else {
				return val;
			}
		}
		else if ( typeof val === 'number' ){
			return Math.abs(val);
		}
		else {
			return val;
		}
		
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/abs.pipe.ts